"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var css = require("./index.scss");
var omi_1 = require("omi");
var index_1 = require("@material/textfield/index");
require("../icon");
function extract(from, props) {
    var to = {};
    props.forEach(function (prop) {
        if (from[prop] !== undefined) {
            to[prop] = from[prop];
        }
    });
    return to;
}
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focus = function () {
            _this.mdc.focus();
        };
        _this.layout = function () {
            _this.mdc.layout();
        };
        _this.refIt = function (e) { _this.root = e; };
        return _this;
    }
    TextField.prototype.installed = function () {
        this.mdc = new index_1.MDCTextField(this.root);
    };
    TextField.prototype.uninstall = function () {
        this.mdc.destroy();
    };
    TextField.prototype.render = function (props) {
        var cls = omi_1.extractClass(props, 'mdc-text-field', {
            'mdc-text-field--outlined': props.outlined,
            'mdc-text-field--fullwidth': props.fullWidth,
            'mdc-text-field--textarea': props.textarea,
            'mdc-text-field--disabled': props.disabled,
            'mdc-text-field--with-leading-icon': (props.path || props.paths) && !props.iconRight,
            'mdc-text-field--with-trailing-icon': (props.path || props.paths) && props.iconRight
        });
        var inputProps = extract(props, ['disabled', 'required', 'pattern', 'value', 'minLength', 'maxLength', 'min', 'max', 'step']);
        if (props.fullWidth && !props.outlined) {
            inputProps.placeholder = props.label;
            props.label = null;
        }
        var vd = [
            omi_1.h("div", __assign({ ref: this.refIt }, cls),
                (props.path || props.paths) && !props.iconRight && omi_1.h("m-icon", __assign({ class: 'icon' }, extract(props, ['path', 'paths']))),
                props.counter && props.textarea && omi_1.h("div", { class: "mdc-text-field-character-counter" }),
                props.textarea ?
                    omi_1.h("textarea", __assign({ id: "my-text-field", class: "mdc-text-field__input", rows: props.rows, cols: props.cols }, inputProps)) :
                    omi_1.h("input", __assign({ type: "text", id: "my-text-field", class: "mdc-text-field__input" }, inputProps)),
                props.outlined ?
                    omi_1.h("div", { class: "mdc-notched-outline" },
                        omi_1.h("div", { class: "mdc-notched-outline__leading" }),
                        omi_1.h("div", { class: "mdc-notched-outline__notch" }, props.label === undefined || !props.noLabel && omi_1.h("label", { for: "tf-outlined", class: "mdc-floating-label" }, props.label)),
                        omi_1.h("div", { class: "mdc-notched-outline__trailing" })) :
                    (props.label === undefined || !props.noLabel && omi_1.h("label", { class: "mdc-floating-label", for: "my-text-field" }, props.label)),
                (props.path || props.paths) && props.iconRight && omi_1.h("m-icon", __assign({ class: 'icon' }, extract(props, ['path', 'paths']))),
                !props.outlined && omi_1.h("div", { class: "mdc-line-ripple" }))
        ];
        if (props.helperText || (props.counter && !props.textarea)) {
            vd.push(omi_1.h("div", { class: "mdc-text-field-helper-line" },
                props.helperText && omi_1.h("div", { class: "mdc-text-field-helper-text" + (props.showHelper ? ' mdc-text-field-helper-text--persistent' : '') }, props.helperText),
                props.counter && !props.textarea && omi_1.h("div", { class: "mdc-text-field-helper-line" },
                    omi_1.h("div", { class: "mdc-text-field-character-counter" }))));
        }
        return vd;
    };
    TextField.defaultProps = {
        showHelper: true
    };
    TextField.propTypes = {
        fullWidth: Boolean,
        textarea: Boolean,
        outlined: Boolean,
        noLabel: Boolean,
        showHelper: Boolean,
        helperText: String,
        iconRight: Boolean,
        counter: Boolean,
        //Multi-line Text Field (Textarea) with Character Counter  (textarea+counter)
        label: String,
        required: Boolean,
        pattern: String,
        minLength: Number,
        maxLength: Number,
        min: Number,
        max: Number,
        step: Number,
        rows: Number,
        cols: Number,
        value: String,
        disabled: Boolean,
        useNativeValidation: Boolean,
        valid: Boolean,
        helperTextContent: String,
        //ripple: MDCRipple,
        leadingIconAriaLabel: String,
        trailingIconAriaLabel: String,
        leadingIconContent: String,
        trailingIconContent: String
    };
    TextField.css = css;
    TextField = __decorate([
        omi_1.tag('m-text-field')
    ], TextField);
    return TextField;
}(omi_1.WeElement));
exports.default = TextField;
